// ============================================================================
// SAMPLE TAX ENDPOINTS (Reference Implementation)
// ============================================================================
// Endpoint definitions for Tax Configuration module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Base path for tax endpoints
 */
const BASE_PATH = '/taxes';

/**
 * Tax Endpoints
 */
export const sampleTaxEndpoints = {
  /**
   * Get all taxes
   * GET /taxes
   */
  list: () => buildEndpoint(BASE_PATH),

  /**
   * Get tax by ID
   * GET /taxes/:id
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Create new tax
   * POST /taxes
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update tax
   * PUT /taxes/:id
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete tax
   * DELETE /taxes/:id
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Search taxes
   * POST /taxes/search
   */
  search: () => buildEndpoint(`${BASE_PATH}/search`),

  /**
   * Get taxes by jurisdiction
   * GET /taxes/by-jurisdiction/:jurisdiction
   */
  byJurisdiction: (jurisdiction: string) =>
    buildEndpointWithParams(`${BASE_PATH}/by-jurisdiction/:jurisdiction`, { jurisdiction }),

  /**
   * Get taxes by country
   * GET /taxes/by-country/:country
   */
  byCountry: (country: string) =>
    buildEndpointWithParams(`${BASE_PATH}/by-country/:country`, { country }),

  /**
   * Get taxes effective on date
   * GET /taxes/effective/:date
   */
  effectiveOn: (date: string) =>
    buildEndpointWithParams(`${BASE_PATH}/effective/:date`, { date }),

  /**
   * Calculate tax
   * POST /taxes/calculate
   */
  calculate: () => buildEndpoint(`${BASE_PATH}/calculate`),

  /**
   * Get active taxes
   * GET /taxes/active
   */
  active: () => buildEndpoint(`${BASE_PATH}/active`),

  /**
   * Get tax report
   * POST /taxes/report
   */
  report: () => buildEndpoint(`${BASE_PATH}/report`),

  /**
   * Bulk delete taxes
   * DELETE /taxes/bulk
   */
  bulkDelete: () => buildEndpoint(`${BASE_PATH}/bulk`),

  /**
   * Export taxes
   * GET /taxes/export
   */
  export: () => buildEndpoint(`${BASE_PATH}/export`),

  /**
   * Import taxes
   * POST /taxes/import
   */
  import: () => buildEndpoint(`${BASE_PATH}/import`),
} as const;

/**
 * Export endpoints
 */
export default sampleTaxEndpoints;
